import { render, staticRenderFns } from "./bigScreen.vue?vue&type=template&id=3ce4d6a2&scoped=true"
import script from "./bigScreen.vue?vue&type=script&lang=js"
export * from "./bigScreen.vue?vue&type=script&lang=js"
import style0 from "./bigScreen.vue?vue&type=style&index=0&id=3ce4d6a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce4d6a2",
  null
  
)

export default component.exports